module.exports = __webpack_public_path__ + "img/location.91c0e8b7.svg";